import React from "react";

const initialContext = {};

const APIContext = React.createContext(initialContext);

export default APIContext;
